// Vendors
import React from 'react'
import { useParams } from 'react-router'

// Components
import { BlogFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

// Types

import { PageMetaSetting } from './meta'

export const PageBlogShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <LayoutLoggedPageList title={title}>
      <BlogFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
